import type { Meta, Reference } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSBanner, CMSReference, useCMSReference } from '@swf/cms';

import useGeoVisibility from '../../CMSContainer/hooks/useGeoVisibility';
// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../CMSRotator.scss';

interface Props {
  item: Reference;
}

const CMSRotatorItem: React.FC<Props> = ({ item }) => {
  const { banner, body, visibility_rules: visibilityRules } = useCMSReference<Meta>(item) as Meta;
  const [isVisible] = useGeoVisibility(visibilityRules);

  if (!isVisible) {
    return null;
  }

  return (
    <>
      {banner && <CMSBanner {...banner} />}
      <div className={styles.contentWrapper}>
        {body?.map((item, itemIndex) => (
          <CMSReference key={itemIndex} {...item} />
        ))}
      </div>
    </>
  );
};

export default CMSRotatorItem;
